import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import ElementUI from 'element-ui';
import lendingContentZh from '@/content/lending/zh'
import lendingContentEn from '@/content/lending/en'
import lendingContentJa from '@/content/lending/ja'
import lendingContentKo from '@/content/lending/ko'
import lendingContentDe from '@/content/lending/de'
import lendingContentFr from '@/content/lending/fr'
import lendingContentIt from '@/content/lending/it'
import lendingContentAr from '@/content/lending/ar'
import lendingContentEs from '@/content/lending/es'
import lendingContentHk from '@/content/lending/hk'
import arMessages from './ar'
import deMessages from './de'
import enMessages from './en'
import esMessages from './es'
import frMessages from './fr'
import itMessages from './it'
import jaMessages from './ja'
import koMessages from './ko'
import zhMessages from './zh-CN'
import hkMessages from './zh-HK'

/** 国际化 **/
Vue.use(VueI18n);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
const i18n = new VueI18n({
  locale: 'zh',
  fallbackLocale: 'en',
  messages: {
    'zh': Object.assign({}, zhMessages, zhLocale, lendingContentZh),
    'en': Object.assign({}, enMessages, enLocale, lendingContentEn),
    'ja': Object.assign({}, jaMessages, enLocale, lendingContentJa),
    'ko': Object.assign({}, koMessages, enLocale, lendingContentKo),
    'de': Object.assign({}, deMessages, enLocale, lendingContentDe),
    'fr': Object.assign({}, frMessages, enLocale, lendingContentFr),
    'it': Object.assign({}, itMessages, enLocale, lendingContentIt),
    'ar': Object.assign({}, arMessages, enLocale, lendingContentAr),
    'hk': Object.assign({}, hkMessages, enLocale, lendingContentHk),
    'es': Object.assign({}, esMessages, enLocale, lendingContentEs),
  }
});

export default i18n
